<template>
    <div class="titled-value">
        <small class="titled-value__title">
            {{ props.title }}
        </small>

        <br />

        <span
            class="titled-value__value text text--blurry"
            :class="{
                'text--warning': props.warning,
                'text--success': props.success,
                'text--negative': props.negative,
            }"
        >
            <b>{{ props.value }}</b>

            <component class="titled-value__value-icon svg svg--100" :is="props.icon"></component>
        </span>
    </div>
</template>

<script setup lang="ts">
// Other
import { defineProps, PropType, Component } from 'vue';

const props = defineProps({
    title: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    warning: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    icon: { type: Object as PropType<Component | null>, default: null },
});
</script>

<style lang="scss">
.titled-value {
    width: 6rem;
    text-align: center;
    line-height: 1.25rem;
    text-wrap: nowrap;

    &__title {
        color: var(--text-black-primary);
        @include caption-tertiary();
    }

    &__value {
        position: relative;
    }

    &__value-icon {
        position: absolute;
        top: 0;
        right: -1.125rem;
    }
}
</style>
